<template>
  <!--=== banner ==========-->
  <div v-if="bannerTopo.length > 0" class="top-banner-area topo-cel">
    <div class="top-banner-content">

      <img
        class="top-banner-image"
        :src="$imgURL + bannerTopo[0].insInstitucionalImagens[0].itgUrlImagem"
        :alt="bannerTopo[0].itiNome"
      />

      <div class="top-banner-overlay">
        <div class="container">
          <div class="row align-items-center h-100">
            <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
              <div class="hero-caption hero-caption2">
                <h2>{{ bannerTopo[0].itiNome }}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
  <!--  final banner -->

  <!--=== sobre ==========-->
  <div v-if="quemSomos != ''" class="support-company-area section-padding">
    <div class="container">
      <div class="row align-items-center justify-content-between">
        <div class="col-xl-5 col-lg-5 col-md-10">
          <div class="support-location-img">
            <img :src="$imgURL + quemSomos[0].insInstitucionalImagens[0].itgUrlImagem" alt="" style="border-radius: 5px;">
          </div>
        </div>
        <div class="col-xl-7 col-lg-7 col-md-10">
          <div class="right-caption">
            <!-- Section Tittle -->
            <div class="section-tittle" style="padding-top: 20px;">
              <h2>{{ quemSomos[0].itiNome }}</h2>
            </div>
            <div class="support-caption">
              <p v-html="quemSomos[0].itiResumo1" class="pera-top"></p>

            </div>
          </div>
        </div>
          <div class="col-xl-12 col-lg-12 col-md-12">
            <div class="right-caption">
             <div class="support-caption">
             <p v-html="quemSomos[0].itiResumo2" class="pera-top"></p>
             </div>
             </div>
          </div>
      </div>
    </div>
  </div>
  <!-- final sobre -->

  <!--=== numeros ==========-->



  
  <div v-if="numeros != ''" class="count-down-area pt-20 section-img-bg2">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-12 col-md-12">
          <div class="count-down-wrapper">
            <div class="row justify-content-between">
              <div v-for="itemNumero in numeros" :key="itemNumero.itiId" class="col-lg-3 col-md-6 col-sm-6">
                <div class="single-counter d-flex align-items-center">
                  <div class="counter-img">
                    <img :src="$imgURL + itemNumero.insInstitucionalImagens[0].itgUrlImagem" alt="">
                  </div>
                  <div class="captions">
                       <VueJsCounter :start="0" :end="itemNumero.itiReferencia" :duration="7000"
                          class="counter" /><span class="plus">{{ itemNumero.itiCampoExtra1 }}</span>                   
                    <p class="color-green">{{ itemNumero.itiNome }}</p>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- final numeros -->

  <!--=== missao visao ==========-->
  <div v-if="missaoVisao != ''" class="our-services section-padding position-relative">
    <div class="container">
      <div class="row justify-content-center">

        <div v-for="missao in missaoVisao" :key="missao.itiId" class="col-xxl-3 col-xl-6 col-lg-6 col-md-6 col-sm-6">
          <div class="single-services text-center mb-30">
            <div class="services-cap">
              <h3 style="padding-bottom: 20px;">{{ missao.itiNome }}</h3>
              <p v-html="missao.itiResumo1"></p>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
  <!-- final missao -->

  <PageCallAction></PageCallAction>

  <!--=== mascote ==========-->
  <div v-if="mascote != ''" class="join-us-area section-padding">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-xl-4 col-lg-6 col-md-10">
          <div class="joing-details">
            <div class="section-tittle">
              <h2>{{ mascote[0].itiNome }}</h2>
            </div>
            <p v-html="mascote[0].itiResumo1"></p>
          </div>
        </div>
        <div class="offset-xl-1 col-xl-4 col-lg-4 col-md-7 col-sm-7">
          <div class="joning-img">
            <img :src="$imgURL + mascote[0].insInstitucionalImagens[0].itgUrlImagem" alt="" class="w-100">
          </div>
        </div>
        <div class="col-xl-3 col-lg-3 col-md-5 col-sm-5">
          <div class="joning-img">
            <img :src="$imgURL + mascote[0].insInstitucionalImagens[1].itgUrlImagem" alt="" class="w-100">
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- final mascote -->

</template>

<script>
import PageCallAction from '../components/PageCallAction.vue'
import { useHead } from '@vueuse/head'
import axios from 'axios'

export default {
  name: 'SobreView',
  components: {
    PageCallAction,
  },

  data: () => ({
    bannerTopo: [],
    quemSomos: [],
    numeros: [],
    missaoVisao: [],
    mascote: [],
  }),

  methods: {
    carregaMetas(texto, titulo) {
      useHead({
        title: 'Igor Paper - ' + titulo,
        meta: [
          { name: "description", content: texto },
          { name: "author", content: "Igor Paper" },
          { httpEquiv: "Content-Language", content: "pt-BR" },
          { charset: "UTF-8" },
          { name: "robots", content: "index, follow" },
        ],
      })
    },
    removerTagsHTML(html) {
      const element = document.createElement('div');
      element.innerHTML = html;
      return element.textContent || element.innerText || '';
    },
  },

  created() {
    this.carregaMetas("A Igor Paper nasceu em 2016, fruto da visão de Igor, que, ao assistir a um vídeo no canal Pequenas Empresas & Grandes Negócios, enxergou uma oportunidade única de empreender. Motivado pela paixão em oferecer produtos de qualidade e conforto, adquiriu sua primeira máquina e, com muito esforço, iniciou a produção na garagem de casa.", "Sobre");

    // bannerTopo
    axios.get('/Process/InsInstitucional/institucional/11/sobretopo/0/x')
      .then(response => {
        this.bannerTopo = response.data;
        this.carregaMetas(this.removerTagsHTML(this.bannerTopo[0].itiReferencia), this.bannerTopo[0].itiNome);
        //console.log('banner topo')
        //console.log(this.bannerTopo)
      })
      .catch(error => {
        console.error(error);
      });

    // texto quem somos
    axios.get('/Process/InsInstitucional/institucional/12/sobre/0/x')
      .then(response => {
        this.quemSomos = response.data;
        this.carregaMetas(this.removerTagsHTML(this.quemSomos[0].itiReferencia), this.quemSomos[0].itiNome);
        //console.log('quemSomos')
        //console.log(this.quemSomos)
      })
      .catch(error => {
        console.error(error);
      });

    // numeros
    axios.get('/Process/InsInstitucional/institucional/47/homenumeros/0/x')
      .then(response => {
        this.numeros = response.data.filter(x=> x.itiVisivel);
        //console.log('numeros')
        //console.log(this.numeros)
      })
      .catch(error => {
        console.error(error);
      });

    // missao, visao
    axios.get('/Process/InsInstitucional/institucional/37/sobreitens/0/x')
      .then(response => {
        this.missaoVisao = response.data;
        //console.log('missaoVisao')
        //console.log(this.missaoVisao)
      })
      .catch(error => {
        console.error(error);
      });

    // mascote
    axios.get('/Process/InsInstitucional/institucional/48/sobremascote/0/x')
      .then(response => {
        this.mascote = response.data;
        console.log('mascote')
        console.log(this.mascote)
      })
      .catch(error => {
        console.error(error);
      });

  }

}
</script>

<style scoped>
.top-banner-area {
  width: 100%;
  overflow: hidden;
}

.top-banner-content {
  position: relative;
  width: 100%;
  height: clamp(180px, 26vw, 420px);
  background: #000;
}

.top-banner-image {
  width: 100%;
  height: 100%;
  /*object-fit: contain; /* mostra a imagem inteira */
  object-position: center;
  display: block;
}

.top-banner-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
}

.top-banner-overlay .container,
.top-banner-overlay .row {
  height: 100%;
}

.hero-caption2 {
  color: #fff;
}

.hero-caption2 h2 {
  margin: 0;
  color: #fff;
}

/* notebook 1366 */
@media (min-width: 1200px) and (max-width: 1366px) {
  .top-banner-content {
    height: 300px;
  }
}

/* tablet */
@media (max-width: 991px) {
  .top-banner-content {
    height: 240px;
  }
}

/* mobile */
@media (max-width: 767px) {
  .top-banner-content {
    height: 160px;
  }

  .top-banner-image {
    object-fit: cover;
  }

  .hero-caption2 h2 {
    font-size: 22px;
  }
}
</style>